import React, { useState } from "react";
import { Rectangle } from "@react-google-maps/api";
import { Site } from "../../types/site";
import { convertSiteToBound, isSiteRegistered } from "../../utils/siteUtils";
import { Bounds } from "../../types/bounds";

type Props = {
  initCenter: { lat: number; lng: number }; // [lat, lon]
  initHeight: number; // 縦幅
  initWidth: number; // 横幅
  onBoundsChange: (bounds: Bounds) => void;
  site: Site;
};

const GeoSelectionRectangle: React.FC<Props> = ({ initCenter, initHeight, initWidth, onBoundsChange, site }) => {
  const initBounds = isSiteRegistered(site)
    ? convertSiteToBound(site)
    : {
        north: initCenter.lat + initHeight / 2.0,
        south: initCenter.lat - initHeight / 2.0,
        west: initCenter.lng - initWidth / 2.0,
        east: initCenter.lng + initWidth / 2.0,
      };

  const [rectangle, setRectangle] = useState<google.maps.Rectangle | null>(null);

  const handleLoad = (rect: google.maps.Rectangle) => {
    setRectangle(rect);
  };

  const options = {
    strokeColor: "#EB5B00",
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: "#EB5B00",
    fillOpacity: 0.35,
    visible: true,
  };

  const handleBoundsChanged = () => {
    if (rectangle) {
      const newBounds = rectangle.getBounds();
      if (newBounds) {
        const ne = newBounds.getNorthEast();
        const sw = newBounds.getSouthWest();
        const updatedBounds = {
          north: ne.lat(),
          south: sw.lat(),
          east: ne.lng(),
          west: sw.lng(),
        };
        onBoundsChange(updatedBounds);
      }
    }
  };

  return (
    <>
      <Rectangle
        bounds={initBounds}
        options={options}
        draggable={true}
        editable={true}
        onLoad={handleLoad}
        onBoundsChanged={handleBoundsChanged}
      />
    </>
  );
};

export default GeoSelectionRectangle;
